import {Step} from "../types";

export const MAX_DESCRIPTION_LENGTH: number = 150;